/* Browser visibility gate, not an access-control boundary. The public JSON feed remains public
   by Peter's explicit choice. No cart or checkout request is made by this script. */
(() => {
  const content = document.getElementById('bf-private-content');
  if (!content) return;
  const unlock = () => {
    if (!content.isConnected) return;
    let code = window.__bfTestCode || '';
    try { code = code || sessionStorage.getItem('bf-test:code') || ''; } catch {}
    if (!window.bfInsider?.isActive() && !window.bfInsider?.isCode(code)) return;
    document.getElementById('bf-private-locked')?.remove();
    document.title = 'Black Weeks · Lelafine';
    const fragment = content.content.cloneNode(true);
    const scripts = [...fragment.querySelectorAll('script:not([type="application/json"])')];
    const types = scripts.map((script) => script.getAttribute('type'));
    // Cloned template scripts can execute when attached. Keep them inert until our ordered replay.
    scripts.forEach((script) => { script.type = 'application/x-bf-inert'; });
    content.replaceWith(fragment);
    // Scripts inside a template are inert. Recreate only after the gate passed, in order.
    for (const [index, original] of scripts.entries()) {
      const script = document.createElement('script');
      for (const attr of original.attributes) {
        if (attr.name !== 'type') script.setAttribute(attr.name, attr.value);
      }
      if (types[index]) script.type = types[index];
      script.async = false;
      script.textContent = original.textContent;
      original.replaceWith(script);
    }
    // The entry script's ready listener may have been installed after DOMContentLoaded.
    document.dispatchEvent(new Event('bf:collection-unlocked'));
  };
  unlock();
  const settle = () => {
    unlock();
    if (!content.isConnected) return;
    const locked = document.getElementById('bf-private-locked');
    if (locked) {
      document.title = locked.dataset.lockedTitle;
      locked.hidden = false;
      locked.style.removeProperty('display');
    }
  };
  // Never paint the 404 while recognised test/personal access is still resolving.
  Promise.resolve(window.bfInsider?.ready).then(settle, settle);
  window.addEventListener('welcome-discount:code-changed', unlock);
})();
